"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LEVELS = {
  DEBUG: "debug",
  INFO: "info",
  WARNING: "warn",
  ERROR: "error"
};
var LEVEL_LABELS = {
  [LEVELS.DEBUG]: "debug",
  [LEVELS.INFO]: "info",
  [LEVELS.WARNING]: "warn",
  [LEVELS.ERROR]: "error"
};
var LEVEL_COLORS = {
  [LEVELS.DEBUG]: "#00CCFF",
  [LEVELS.INFO]: "#6600CC",
  [LEVELS.WARNING]: "#FF9933",
  [LEVELS.ERROR]: "#CC3333"
};
var DEFAULT_CONTEXT = "app";

/**
 * Fast and simple dev logger
 * @description Logs visible only in development environment
 * @class
 * @example
 * ```ts
 * const logger = new Logger('test')
 * logger.debug('Test message', { a: 'b', b: 'a' })
 * ```
 */
var Logger = /*#__PURE__*/function () {
  /**
   * @param context Logger context
   */
  function Logger(context) {
    if (context === void 0) {
      context = DEFAULT_CONTEXT;
    }
    this.context = context;
  }

  /**
   * Print log message to console
   * @param level Log level
   * @param message Text message
   * @param [meta] Additional data
   */
  var _proto = Logger.prototype;
  _proto.log = function log(level, message, meta) {
    if (process.env.NODE_ENV === "development") {
      var label = this.context;
      var color = LEVEL_COLORS[level];
      var labelStyle = "font-weight: bold; color: " + color;
      var ctxStyle = "font-weight: bold; color: #CC00FF";
      var msgStyle = "font-weight: normal;";
      var time = new Date().toLocaleTimeString();
      if (typeof message === "object") {
        console.log("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " ", msgStyle, labelStyle, ctxStyle, message);
      } else if (typeof meta !== "undefined") {
        console.groupCollapsed("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " %c" + message, msgStyle, labelStyle, ctxStyle, msgStyle);
        console.log(meta);
        console.groupEnd();
      } else {
        console.log("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " %c" + message, msgStyle, labelStyle, ctxStyle, msgStyle);
      }
    }
  }

  /**
   * Print log with debug level
   * @param message Text message
   * @param meta Additional data
   */;
  _proto.debug = function debug(message, meta) {
    this.log(LEVELS.DEBUG, message, meta);
  }

  /**
   * Print log with info level
   * @param message Text message
   * @param meta Additional data
   */;
  _proto.info = function info(message, meta) {
    this.log(LEVELS.INFO, message, meta);
  }

  /**
   * Print log with warning level
   * @param message Text message
   * @param meta Additional data
   */;
  _proto.warn = function warn(message, meta) {
    this.log(LEVELS.WARNING, message, meta);
  }

  /**
   * Print log with error level
   * @param message Text message
   * @param meta Additional data
   */;
  _proto.error = function error(message, meta) {
    this.log(LEVELS.ERROR, message, meta);
  };
  return Logger;
}();
var _default = Logger;
exports.default = _default;